export default "/images/vendor/flag-icon-css/flags/1x1/va.svg?555e01bd279c6bbc28c4b4bd85a47582";